module.exports = __webpack_public_path__ + "img/product_15.817d5bc.jpg";